import { render, staticRenderFns } from "./RosettePopupContent.vue?vue&type=template&id=4fa325f0&scoped=true&"
import script from "./RosettePopupContent.vue?vue&type=script&lang=js&"
export * from "./RosettePopupContent.vue?vue&type=script&lang=js&"
import style0 from "./RosettePopupContent.vue?vue&type=style&index=0&id=4fa325f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa325f0",
  null
  
)

export default component.exports